import Immutable from 'immutable';
import { propertyListActionTypes } from '~constants/actionTypes';
import { defaultCommunicationObject, updateCommunicationObject } from '~reducers/shared';

export const defaultState = Immutable.fromJS({
  list: {
    payload: [],
    total: 0,
  },
  communication: defaultCommunicationObject,
});

const formatPayload = properties =>
  properties.map(property => ({
    key: property.node.slug,
    name: property.node.name,
    id: property.node.id,
    slug: property.node.slug,
    countryName: property.node.city.country.name,
    averageRating: property.node.reviewsSummary.averageRating,
    countrySlug: property.node.city.country.slug,
    cityName: property.node.city.name,
    citySlug: property.node.city.slug,
    cityPublished: property.node.city.published,
    landlordName: property.node.landlord.name,
    businessScale: property.node.landlord.businessScale,
    statuses: property.node.status,
    updatedAt: property.node.updatedAt,
    updatedBy: property.node.updatedByUser ? property.node.updatedByUser.name : '',
    address: property.node.address,
    zipCode: property.node.zipCode,
    totalBeds: property.node.totalBeds,
    headline: property.node.headline,
    headlineCn: property.node.headlineCn,
    description: property.node.description,
    descriptionCn: property.node.descriptionCn,
    image:
      property.node.images && property.node.images.edges
        ? property.node.images.edges.find(image => image.node.hero)
        : null,
    state: property.node.state,
    commissionTiers: property.node.commissionTiers,
    drafts:
      property.node.drafts &&
      property.node.drafts.edges &&
      property.node.drafts.edges &&
      property.node.drafts.edges[0] &&
      property.node.drafts.edges[0].node
        ? property.node.drafts.edges[0].node
        : {},
    propertyType: property.node.propertyType,
    bookingJourney: property.node.bookingJourney,
    contractStage: property.node.contractStage,
    landlord: property.node.landlord,
    contracts: property.node.contracts,
    publishCondition: property.node.publishCondition,
    paymentPlan: property.node.paymentPlan,
  }));

const propertyListReducer = (state = defaultState, action) => {
  switch (action.type) {
    case propertyListActionTypes.INITIALIZE:
      return state;

    case propertyListActionTypes.SET_LIST: {
      const nextState = state.deleteIn(['list', 'payload']);
      return nextState.mergeDeep({
        list: {
          payload: formatPayload(action.payload.edges),
          total: action.payload.totalCount,
        },
      });
    }

    case propertyListActionTypes.LIST_CS:
      return state.mergeDeep({
        communication: updateCommunicationObject(action.status, action.error),
      });

    case propertyListActionTypes.SET_PROPERTY_IN_LIST: {
      const properties = state.getIn(['list', 'payload']).toJS();
      properties[action.index] = action.property;
      return state.mergeDeep({
        list: {
          payload: properties,
        },
      });
    }

    default:
      return state;
  }
};

export default propertyListReducer;
